import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setChalkAssets } from 'ai-tutor-player';

import { App } from './App';
import { adminChalkAssets } from '@/lib/chalkAssets';

import '@/styles/globals.css';
import 'ai-tutor-player/player.css';

// Chalk fonts for the shared player's handwriting — registered ONCE for the
// whole app so every surface that renders the player (LMS Preview, Teach play
// mode) gets the pencil handwriting, not the plain streaming fallback.
setChalkAssets(adminChalkAssets);

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
